
interface TimeLeft {
    timeLeft: number;
    timeLeft_str?: string;
    unit: string; // '日' or '時間'
}

export const getTimeLeft = (due: number): TimeLeft => {
    // due は「秒」なので「ミリ秒」に変換
    const dueDate = new Date(due * 1000);
    const now = new Date();
    const diff = dueDate.getTime() - now.getTime();

    if (diff < 0) {
        return { timeLeft: 0, unit: "時間" };
    }

    const year = dueDate.getFullYear();
    const month = String(dueDate.getMonth() + 1).padStart(2, '0');
    const day = String(dueDate.getDate()).padStart(2, '0');
    const timeLeft_str = `${year}/${month}/${day} 23:59`;

    const hoursLeft = diff;

    return { timeLeft: hoursLeft, timeLeft_str: timeLeft_str, unit: "まで" };

};

export const formatNumber = (num: number): string => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * Carbonの日付をAsia/TokyoタイムゾーンでYYYY-MM-DD形式に変換する
 * @param value - 日付文字列（例: '2026-01-23T15:00:00.000000Z' または '2026-01-24T00:00:00+09:00'）、Dateオブジェクト、またはnull/undefined
 * @returns YYYY-MM-DD形式の文字列、または空文字列
 */
export const formatDateForInput = (value: string | Date | null | undefined): string => {
    if (!value) return "";

    let date: Date;
    if (typeof value === "string") {
        // 文字列が既にYYYY-MM-DD形式の場合はそのまま返す
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            return value;
        }
        // Carbonから来る日付文字列をパース
        // 例: '2026-01-23T15:00:00.000000Z' → UTCとして解釈される
        date = new Date(value);
    } else {
        date = new Date(value);
    }

    // Asia/Tokyoタイムゾーンで日付を取得して、元のAsia/Tokyoの日付を復元
    const formatter = new Intl.DateTimeFormat('ja-JP', {
        timeZone: 'Asia/Tokyo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });

    const parts = formatter.formatToParts(date);
    const year = parts.find(p => p.type === 'year')?.value;
    const month = parts.find(p => p.type === 'month')?.value;
    const day = parts.find(p => p.type === 'day')?.value;

    return `${year}-${month}-${day}`;
};